
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[slug]/entrar",
      function () {
        return require("private-next-pages/org/[slug]/entrar/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[slug]/entrar"])
      });
    }
  